package com.shadowings.gero.data.lessons.chapter12

import com.shadowings.gero.data.lessons.inlineMeaning
import androidx.compose.ui.unit.dp
import com.shadowings.gero.data.lessons.buildVocabQuizContent
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_vocab_dei_sovrani_alyn_1
import gero.composeapp.generated.resources.exp_content_vocab_dei_sovrani_nilo_1
import gero.composeapp.generated.resources.exp_content_word_reading_and_meaning
import gero.composeapp.generated.resources.exp_title_word_name
import gero.composeapp.generated.resources.lesson_vocab_dei_sovrani_title
import gero.composeapp.generated.resources.osiride
import gero.composeapp.generated.resources.ramses

fun getVocabDeiSovraniContent(words: List<Word>, languageCode: String): List<IExplanation> {
    val intro = listOf(
        ExplanationContent(
            title = Res.string.lesson_vocab_dei_sovrani_title,
            content = Res.string.exp_content_vocab_dei_sovrani_alyn_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.lesson_vocab_dei_sovrani_title,
            content = Res.string.exp_content_vocab_dei_sovrani_nilo_1,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
    )

    val slides = deiSovraniWordIds
        .mapNotNull { id -> words.firstOrNull { it.id == id } }
        .map { word ->
            ExplanationContent(
                title = Res.string.exp_title_word_name,
                titleArgs = listOf(word.getMeaning(languageCode)),
                content = Res.string.exp_content_word_reading_and_meaning,
                contentArgs = listOf(
                    word.reading,
                    word.inlineMeaning(languageCode),
                    word.getNote(languageCode)
                ),
                face = Faces.Happy,
                character = Characters.Nilo,
                composable = { MdCWord(word.gardiner, rtl = false, cart = false, size = 96.dp) },
                wordId = word.id
            )
        }

    val imageSlides = listOf(
        ExplanationContent(
            title = Res.string.lesson_vocab_dei_sovrani_title,
            face = Faces.Happy,
            image = Res.drawable.osiride,
            imageSize = 0.75f,
            applyFilter = false,
            fullscreenable = true
        ),
        ExplanationContent(
            title = Res.string.lesson_vocab_dei_sovrani_title,
            face = Faces.Serious,
            image = Res.drawable.ramses,
            imageSize = 0.75f,
            applyFilter = false,
            fullscreenable = true
        )
    )

    return intro + slides + imageSlides
}

private val deiSovraniOldWordIds = listOf(
    "HA", "DEN", "INEPU", "ITEN", "ANY", "SOKAR", "PTAH", "TAURET", "ITETI", "AKER",
    "IMN", "HAT", "TWT", "ANKH", "NFRHTP", "AMENEMHAT", "TUTANKHAMUN", "MENTUHOTEP"
)

fun getVocabDeiSovraniQuizContent(
    explanations: List<IExplanation>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    val baseQuizzes = buildVocabQuizContent(
        explanations = explanations,
        words = words,
        languageCode = languageCode,
        additionalOptions = setOf("PTAH", "SOKAR")
    )

    val newWords = deiSovraniWordIds.mapNotNull { id -> words.firstOrNull { it.id == id } }
    val oldWords = deiSovraniOldWordIds.mapNotNull { id -> words.firstOrNull { it.id == id } }

    val multiPressNew = buildMultiPress(newWords.shuffled().take(4), languageCode)
    val multiPressMixed = buildMultiPress(
        (newWords.shuffled().take(2) + oldWords.shuffled().take(2)).shuffled(),
        languageCode
    )
    val multiPressOld = buildMultiPress(oldWords.shuffled().take(4), languageCode)

    return (baseQuizzes + multiPressNew + multiPressMixed + multiPressOld).shuffled()
}
